import { combineReducers } from 'redux';

const defaultCreateBoxOpen = false;
const createBoxOpen = (state = defaultCreateBoxOpen, action) => {
  switch (action.type) {
    case 'CREATE_BOX_OPEN':
      return true;
    case 'CREATE_BOX_CANCEL':
    case 'EPIK_BOX_CREATE_SUCCESS':
    case 'EPIK_BOX_CREATE_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultUpdateBoxOpen = false;
const updateBoxOpen = (state = defaultUpdateBoxOpen, action) => {
  switch (action.type) {
    case 'UPDATE_BOX_OPEN':
      return true;
    case 'UPDATE_BOX_CANCEL':
    case 'EPIK_BOX_UPDATE_SUCCESS':
    case 'EPIK_BOX_UPDATE_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultBoxToActivate = null;
const boxToActivate = (state = defaultBoxToActivate, action) => {
  switch (action.type) {
    case 'ACTIVATE_EPIK_BOX_SUCCESS':
      return action.data;
    default:
      return state;
  }
};

const defaultLockStatus = null;
const lockStatusEpikBox = (state = defaultLockStatus, action) => {
  switch (action.type) {
    case 'BOX_LOCK_STATUS_SUCCESS':
      return action.data;
    default:
      return state;
  }
};

const defaultAlarmTimerStatus = null;
const alarmTimerStatus = (state = defaultAlarmTimerStatus, action) => {
  switch (action.type) {
    case 'GET_ALARM_TEST_SUCCESS':
      return action.getAlarmTest;
    default:
      return state;
  }
};

const defaultSelectedNotesTab = '1';
const notesSelectedTab = (state = defaultSelectedNotesTab, action) => {
  switch (action.type) {
    case 'SELECTED_NOTES_TAB':
      return action.tab;
    default:
      return state;
  }
};

const defaultPriFailoversData = [];
const priFailoversData = (state = defaultPriFailoversData, action) => {
  switch (action.type) {
    case 'SET_PRI_FAILOVERS_LIST':
      return action.data;
    default:
      return state;
  }
};

const defaultcasFailoversData = [];
const casFailoversData = (state = defaultcasFailoversData, action) => {
  switch (action.type) {
    case 'SET_CAS_FAILOVERS_LIST':
      return action.data;
    default:
      return state;
  }
};

const notesTabFilters = {
  email: '',
  type: 'allUsers',
};
const selectedNotesTabFilters = (state = notesTabFilters, action) => {
  switch (action.type) {
    case 'NOTES_TAB_FILTERS':
      return action.filters;
    default:
      return state;
  }
};

const defaultESimStatus = false;
const boxESimStatus = (state = defaultESimStatus, action) => {
  switch (action.type) {
    case 'ESIM_STATUS_SUCCESS':
      if (
        JSON.stringify(action.data)
          .toLowerCase()
          .includes('backup')
      ) {
        return true;
      }
      return false;
    default:
      return state;
  }
};

const defaultBoxToUpdate = null;
const boxToUpdate = (state = defaultBoxToUpdate, action) => {
  switch (action.type) {
    case 'UPDATE_BOX_OPEN':
      return action.box;
    case 'UPDATE_BOX_CANCEL':
    case 'EPIK_BOX_UPDATE_SUCCESS':
    case 'EPIK_BOX_UPDATE_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultOptionsBox = {
  optionsBox: {
    slaveBoxes: [],
    advancedMonitoring: '',
    monitor: '',
    model: '',
  },
};
const optionsBoxUpdate = (state = defaultOptionsBox, action) => {
  switch (action.type) {
    case 'OPTIONS_BOX_CHANGE':
      return {
        ...state,
        optionsBox: action.boxData,
      };
    case 'EDIT_OPTIONS_CHANGE':
      if (action.name === 'boxType') {
        state.optionsBox.boxType = action.value;
      } else if (action.name === 'addSlaveBox') {
        state.optionsBox.slaveBoxes.push(action.value);
      } else if (action.name === 'removeSlaveBox') {
        state.optionsBox.slaveBoxes.splice(action.value, 1);
      } else if (action.name === 'advancedMonitoring') {
        state.optionsBox.advancedMonitoring = action.value;
      } else if (action.name === 'monitoring') {
        state.optionsBox.monitor = action.value;
      } else if (action.name === 'boxModel') {
        state.optionsBox.model = action.value;
      } else {
        state.optionsBox.features[action.name] = action.value;
      }
      return {
        ...state,
        optionsBox: state.optionsBox,
      };
    default:
      return state;
  }
};

const defaultPriBox = {
  priBox: '',
};
const priBoxUpdate = (state = defaultPriBox, action) => {
  switch (action.type) {
    case 'PRI_BOX_CHANGE':
      return {
        ...state,
        priBox: action.boxData,
      };
    case 'EDIT_PRI_CHANGE':
      if (action.name === 'priType') {
        state.priBox.priType = action.value;
      } else if (action.name === 'priClocking') {
        state.priBox.priClocking = action.value;
      } else if (action.name === 'switchType') {
        state.priBox.switchType = action.value;
      } else if (action.name === 'framing') {
        state.priBox.framing = action.value;
      } else if (action.name === 'encoding') {
        state.priBox.encoding = action.value;
      } else if (action.name === 'dnis') {
        state.priBox.dnis = action.value;
      }
      return {
        ...state,
        priBox: state.priBox,
      };
    default:
      return state;
  }
};

const defaultboxEpiToDelete = null;
const boxEpiToDelete = (state = defaultboxEpiToDelete, action) => {
  switch (action.type) {
    case 'DELETE_BOX_EPI_OPEN':
      return action.obi;
    case 'DELETE_BOX_EPI_CANCEL':
    case 'EPIK_BOX_EPI_DELETE_SUCCESS':
    case 'EPIK_BOX_EPI_DELETE_ERROR':
      return null;
    default:
      return state;
  }
};

const defaultBoxExternal = null;
const boxExternalAta = (state = defaultBoxExternal, action) => {
  switch (action.type) {
    case 'ASSIGN_ATA_SUCCESS':
      return action.assignedAta;
    default:
      return state;
  }
};

const defaultDeleteEpikEpiOpen = false;
const deleteEpikEpiOpen = (state = defaultDeleteEpikEpiOpen, action) => {
  switch (action.type) {
    case 'DELETE_BOX_EPI_OPEN':
      return true;
    case 'DELETE_BOX_EPI_CANCEL':
    case 'EPIK_BOX_EPI_DELETE_SUCCESS':
    case 'EPIK_BOX_EPI_DELETE_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultDeleteBoxOpen = false;
const deleteBoxOpen = (state = defaultDeleteBoxOpen, action) => {
  switch (action.type) {
    case 'DELETE_BOX_OPEN':
      return true;
    case 'DELETE_BOX_CANCEL':
    case 'EPIK_BOX_DELETE_SUCCESS':
    case 'EPIK_BOX_DELETE_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultBoxToDelete = null;
const boxToDelete = (state = defaultBoxToDelete, action) => {
  switch (action.type) {
    case 'DELETE_BOX_OPEN':
      return action.box;
    case 'DELETE_BOX_CANCEL':
    case 'EPIK_BOX_DELETE_SUCCESS':
    case 'EPIK_BOX_DELETE_ERROR':
      return null;
    default:
      return state;
  }
};

const defaultBoxPagination = { page: 1, limit: 10 };
const pagination = (state = defaultBoxPagination, action) => {
  switch (action.type) {
    case 'SET_BOX_PAGINATION':
      return action.options;
    case 'CLEAR_BOX_PAGINATION':
      return state;
    default:
      return state;
  }
};

const defaultCompanyFilter = {};
const companyFilter = (state = defaultCompanyFilter, action) => {
  if (action.type === 'EPIK_BOXES_COMPANY_FILTER') {
    return action.filter;
  }
  return state;
};

const defaultAdvanceFilter = [];
const advanceFilters = (state = defaultAdvanceFilter, action) => {
  if (action.type === 'ADVANCE_LOCAL_ARRAY') {
    return action.filter;
  }
  return state;
};

const defaultFilterByStatus = true;
const filterByStatus = (state = defaultFilterByStatus, action) => {
  switch (action.type) {
    case 'FILTER_COMPANY_STATUS':
      return action.status;
    default:
      return state;
  }
};

const defaultSysInfo = '';
const sysInfo = (state = defaultSysInfo, action) => {
  switch (action.type) {
    case 'SYS_INFO_SUCCESS':
      return action.data;
    default:
      return state;
  }
};

const defaultShowPhoneModal = false;
const showPhoneModal = (state = defaultShowPhoneModal, action) => {
  switch (action.type) {
    case 'SHOW_PHONE_MODAL':
      return true;
    case 'HIDE_PHONE_MODAL':
      return false;
    default:
      return state;
  }
};

const defaultSelectedBoxes = [];
const selectedBoxes = (state = defaultSelectedBoxes, action) => {
  switch (action.type) {
    case 'SET_SELECTED_BOXES':
      return action.data;
    default:
      return state;
  }
};

const defaultAlarmTimer = 0;
const initiateAlarmTimer = (state = defaultAlarmTimer, action) => {
  switch (action.type) {
    case 'INITIATE_ALARM_TIMER':
      return action.timer;
    default:
      return state;
  }
};

const defaultFetchResultStatus = false;
const fetchResultStatus = (state = defaultFetchResultStatus, action) => {
  switch (action.type) {
    case 'FETCH_RESULT_VISIBLE':
      return action.status;
    default:
      return state;
  }
};

const defaultProtocolData = {};
const selectedProtocolBody = (state = defaultProtocolData, action) => {
  switch (action.type) {
    case 'SELECTED_PROTOCOL_DATA':
      return action.data;
    default:
      return state;
  }
};
const defaultShowNumberModal = false;
const showNumberModal = (state = defaultShowNumberModal, action) => {
  switch (action.type) {
    case 'SHOW_NUMBER_MODAL':
      return true;
    case 'HIDE_NUMBER_MODAL':
      return false;
    default:
      return state;
  }
};

/* STATE FOR MAKING API CALL FOR RESETTING BOX TO DEFAULT */

/* Default State */
export const defaultResetBoxState = {
  data: {},
  error: '',
  loading: false,
};

/* ENUM */
export const eResetBoxActions = {
  DISPATCH_RESET_BOX_CHANGES_INTO_BOX: 'DISPATCH_RESET_BOX_CHANGES',
  LOADING_RESET_BOX_CHANGES: 'LOADING_REST_BOX_CHANGES',
  ERROR_WHILE_RESETTING_BOX: 'ERROR_WHILE_RESETTING_BOX',
};

/* Reducer */
const resetBoxToDefault = (state = defaultResetBoxState, action) => {
  const { payload, type } = action;
  switch (type) {
    case eResetBoxActions.DISPATCH_RESET_BOX_CHANGES_INTO_BOX:
      return {
        data: payload,
        loading: false,
        error: '',
      };
    case eResetBoxActions.LOADING_RESET_BOX_CHANGES:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case eResetBoxActions.ERROR_WHILE_RESETTING_BOX:
      return {
        data: {},
        error: payload,
        loading: false,
      };
    default:
      return { ...state };
  }
};

/* Global State for handling the Interface Priortity */
export const defaultInterfacePriorityState = null;

/* ENUM */
export const eInterfacePriorty = {
  SET_INTERFACE: 'SET_INTERFACE_PRIORTITY',
};

const interfacePriority = (state = defaultInterfacePriorityState, action) => {
  const { payload, type } = action;
  switch (type) {
    case eInterfacePriorty.SET_INTERFACE:
      return payload;
    default:
      return state;
  }
};

/* Global State for handling the Interface Priority */

const defaultSelectedModalPortType = null;
const selectedModalPortType = (state = defaultSelectedModalPortType, action) => {
  switch (action.type) {
    case 'GET_SELECTED_PORT_MODAL_TYPE_SUCCESS':
      return action.modalType;
    default:
      return state;
  }
};
const initialState = {
  testStatus: false,  // Default state
};
const alarmTestPass = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TEST_STATUS':
      return {
        ...state,
        testStatus: action.payload,
      };
    default:
      return state;
  }
};
const initialStateCompany = {
  suggestionCompany: null,
};
const suggectedCompany = (state = initialStateCompany, action) => {
  switch (action.payload) {
    case 'SET_SUGGESTION_COMPANY':
      return {
        ...state,
        suggestionCompany: action.payload,
      };
    default:
      return state;
  }
};
export default combineReducers({
  boxToUpdate,
  deleteEpikEpiOpen,
  boxEpiToDelete,
  createBoxOpen,
  deleteBoxOpen,
  boxToDelete,
  companyFilter,
  updateBoxOpen,
  filterByStatus,
  sysInfo,
  selectedBoxes,
  showPhoneModal,
  showNumberModal,
  optionsBoxUpdate,
  priBoxUpdate,
  boxToActivate,
  lockStatusEpikBox,
  pagination,
  boxESimStatus,
  advanceFilters,
  initiateAlarmTimer,
  boxExternalAta,
  alarmTimerStatus,
  selectedProtocolBody,
  resetBoxToDefault,
  interfacePriority,
  fetchResultStatus,
  selectedModalPortType,
  notesSelectedTab,
  selectedNotesTabFilters,
  priFailoversData,
  casFailoversData,
  alarmTestPass,
  suggectedCompany
});
